export default "__VITE_ASSET__BsEWWtAs__"